import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from '@mui/material';
import { ChangeEvent, memo } from 'react';

import { breedLib } from 'entities/breed';

import { ESpecie } from 'shared/api';

type Props = {
  filter: string;
  specie: ESpecie;
  totalCount: number;
  onFilterChange: (value: string) => void;
  onSpecieChange: (value: ESpecie) => void;
  addButton?: React.ReactNode;
};

export const BreedsFilters = memo(
  ({ filter, specie, totalCount, onFilterChange, onSpecieChange, addButton }: Props) => {
    const handleFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
      onFilterChange(e.target.value);
    };

    const handleClearFilter = () => {
      onFilterChange('');
    };

    const handleSpecieChange = (e: SelectChangeEvent) => {
      onSpecieChange(e.target.value as ESpecie);
    };

    return (
      <Paper sx={{ mb: 2 }}>
        <Box display="flex" alignItems="center" p="8px 16px" gap={2} flexWrap="wrap">
          <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
            Breeds control panel
          </Typography>

          <Box display="flex" alignItems="center" gap={2} flex={1} minWidth="300px">
            <TextField
              sx={{ minWidth: '350px', maxWidth: '500px', flex: 1 }}
              placeholder="Search breed name, code..."
              size="small"
              value={filter}
              onChange={handleFilterChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: filter && (
                  <IconButton size="small" onClick={handleClearFilter}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />

            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Specie</InputLabel>
              <Select value={specie} label="Specie" onChange={handleSpecieChange}>
                <MenuItem value={ESpecie.Dog}>{breedLib.getSpecieText(ESpecie.Dog)}</MenuItem>
                <MenuItem value={ESpecie.Cat}>{breedLib.getSpecieText(ESpecie.Cat)}</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ minWidth: 'fit-content' }}>
            {totalCount} {totalCount === 1 ? 'breed' : 'breeds'}
          </Typography>

          {addButton && <Box>{addButton}</Box>}
        </Box>
      </Paper>
    );
  },
);

BreedsFilters.displayName = 'BreedsFilters';
